var _defs, _circle, _polygon, _polygon2, _polygon3, _polygon4, _line, _line2, _line3, _line4, _line5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTractorBeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tractor_Beam",
    "data-name": "Tractor Beam",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Tractor-cls-1{fill:#14163d;}.Tractor-cls-2{fill:#ff931e;}.Tractor-cls-3{fill:none;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Tractor-cls-1",
    cx: 35,
    cy: 35,
    r: 35
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "Tractor-cls-2",
    points: "40.75 26.34 27.17 26.34 29.07 21 38.66 21 40.75 26.34"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "Tractor-cls-2",
    points: "44.52 35.84 23.75 35.84 25.65 31 42.43 31 44.52 35.84"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "Tractor-cls-2",
    points: "47.87 45.42 20.7 45.42 22.23 40.63 46.19 40.63 47.87 45.42"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "Tractor-cls-2",
    points: "51.22 55 17.66 55 19.18 50.21 49.54 50.21 51.22 55"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "Tractor-cls-3",
    x1: 42.43,
    y1: 27.74,
    x2: 40.75,
    y2: 24.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "Tractor-cls-3",
    x1: 46.19,
    y1: 36.13,
    x2: 44.52,
    y2: 32.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "Tractor-cls-3",
    x1: 49.54,
    y1: 43.58,
    x2: 47.87,
    y2: 39.85
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "Tractor-cls-3",
    x1: 17.67,
    y1: 47.31,
    x2: 16.14,
    y2: 51.04
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "Tractor-cls-3",
    x1: 52.88,
    y1: 51.04,
    x2: 51.22,
    y2: 47.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Tractor-cls-2",
    d: "M58,55H85s-4-9-14-9S58,55,58,55Z",
    transform: "translate(-37 -37)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractorBeam);
export default __webpack_public_path__ + "static/media/TractorBeam.47b297aae73d735953d317fb998aa3e8.svg";
export { ForwardRef as ReactComponent };